<script>
import managementAPI from '@/api/management';
import ReportTitle from '@/modules/management/components/financial_reports/ReportTitle';
import moment from 'moment';

export default {
  name: 'parts-report',
  data: () => ({
    fromDate: moment().format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD'),
    parts: {},
    loadingItems: false,
    generatedReport: false,
    headers: [
      { text: 'Date Sent', value: 'date_sent' },
      { text: 'Due Date', value: 'date_due' },
      { text: 'Division', value: 'division_display' },
      { text: 'Bill To', value: 'bill_to_obj.name_display' },
      { text: 'Invoice Total', value: 'original_amount', align: 'right' }
    ]
  }),
  methods: {
    async generateReport () {
      this.loadingItems = true;
      this.search = '';
      this.parts = await managementAPI.getPartsReport(this.fromDate, this.toDate);
      console.log(JSON.parse(JSON.stringify(this.parts)));
      this.loadingItems = false;
      this.generatedReport = true;
    },
  },
  components: {
    'report-title': ReportTitle,
  }
}
</script>

<template>
  <div>
    <wc-page-title title='Parts Report'></wc-page-title>
    <v-container>
      <v-row>
        <report-title style="padding-left: 15px;" title='Parts Report' subtitle=''>
	</report-title>
      </v-row>
      <v-row>
        <v-col cols='12' md='12'>
          <wc-data-box title='Setup'>
            <v-card-text>
              <v-row>
                <v-col cols="5">
                  <wc-datepicker label='From date' v-model='fromDate' removeClearOption defaultToday />
                </v-col>
                <v-col cols="5">
                  <wc-datepicker label='To date' v-model='toDate' removeClearOption defaultToday />
                </v-col>
                <v-col class='text-right py-0' cols="2">
                <v-btn style='margin-top: 25px;' depressed  class='primary' @click='generateReport' :loading='loadingItems'>
                  Generate
                </v-btn>
		</v-col>
              </v-row>
            </v-card-text>
          </wc-data-box>
        </v-col>
      </v-row>
      <template v-if='generatedReport'>
        <v-simple-table dense>
            <tbody>
              <template v-for='key in Object.keys(this.parts)'>
                <tr :key='key'>
                  <td>
                    <span class='font-weight-bold text-uppercase'>
                      {{parts[key].desc}}
                    </span>
                  </td>
                  <td></td>
                  <td align="right" width="100">{{ parts[key].qty }}</td>
		</tr>
              </template>
            </tbody>
          </v-simple-table>
      </template>
    </v-container>
  </div>
</template>
